module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_AlignVerticalCenter_16"],"path":[{"$":{"d":"M9,9V7h3V2H9V0H7V2H4V7H7V9H2v5H7v2H9V14h5V9Zm4,4H3V10H13Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_AlignVerticalCenter_16.svg
// module id = diVi
// module chunks = 1